import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'ld-footer-cta',
  templateUrl: './footer-cta.template.html'
})
export class FooterCTAComponent implements OnInit {

  @Input() cancelBtnText: string;
  @Input() cancelBtnDisabled: boolean;
  @Input() submitBtnText: string;
  @Input() submitBtnDisabled: boolean;
  @Input() contentText: string;
  @Output() cancel: EventEmitter<any> = new EventEmitter<any>();
  @Output() submit: EventEmitter<any> = new EventEmitter<any>();

  constructor() {
  }

  ngOnInit() {

  }

  doCancel() {
    this.cancel.emit(null);
  }

  doSave() {
    this.submit.emit(null);
  }
}
